if (!customElements.get('tabs-section-image-comparison')) {
  customElements.define('tabs-section-image-comparison', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      const range = this.querySelector('[data-comparison-range]');
      const stage = this.querySelector('[data-comparison-stage]');
      if (!range || !stage) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const update = () => this.style.setProperty('--comparison-position', `${range.value}%`);
      const move = (event) => {
        const bounds = stage.getBoundingClientRect();
        if (!bounds.width) return;
        range.value = String(Math.round(Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100))));
        update();
      };
      let pointerId = null;
      range.addEventListener('input', update, options);
      range.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.button !== 0) return;
        event.preventDefault();
        pointerId = event.pointerId;
        range.focus({ preventScroll: true });
        range.setPointerCapture(pointerId);
        move(event);
      }, options);
      range.addEventListener('pointermove', (event) => {
        if (event.pointerId === pointerId) move(event);
      }, options);
      const stop = (event) => {
        if (event.pointerId !== pointerId) return;
        if (range.hasPointerCapture(pointerId)) range.releasePointerCapture(pointerId);
        pointerId = null;
      };
      range.addEventListener('pointerup', stop, options);
      range.addEventListener('pointercancel', stop, options);
      range.addEventListener('lostpointercapture', () => { pointerId = null; }, options);
      update();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
